import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { authCallbackError } from './supabase';
import { authErrorParams } from './authErrors';
import { trackEvent } from './analytics';
import { getAuthRedirectPath } from './authRedirect';
import { useGuestCopy } from './guestCopy';

export default function AuthCallbackNotice() {
  const copy = useGuestCopy();
  const location = useLocation();
  const [visible, setVisible] = useState(Boolean(authCallbackError));
  const tracked = useRef(false);
  useEffect(() => {
    if (!authCallbackError || tracked.current) return;
    tracked.current = true;
    trackEvent('auth_callback_error', { method: authCallbackError.method, ...authErrorParams(authCallbackError, authCallbackError.method === 'email' ? 'email_verification' : 'oauth_callback') });
  }, []);
  if (!visible) return null;
  const message = authCallbackError.method === 'apple' && authCallbackError.code === 'invalid_client'
    ? copy.appleUnavailable : authCallbackError.code === 'access_denied'
      ? copy.signinCancelled : ['otp_expired', 'flow_state_expired', 'flow_state_not_found', 'flow_state_already_used',
        'oauth_client_state_not_found', 'oauth_client_state_expired'].includes(authCallbackError.code)
        ? copy.recoveryLinkExpired : copy.signinFailed;
  const from = /^\/(login|signup)(?:[/?#]|$)/.test(location.pathname)
    ? getAuthRedirectPath(location.state) : `${location.pathname}${location.search}`;
  return <div className="guest-notice" role="alert">
    <span>{message} </span>
    <Link to="/login" state={{ from, showEmailLogin: authCallbackError.method === 'email' }} onClick={() => setVisible(false)}>{copy.trySignin}</Link>{' '}
    <button type="button" onClick={() => setVisible(false)} aria-label={copy.dismiss}>{copy.dismiss}</button>
  </div>;
}
